import { render } from "./AdminUsersComponent.vue?vue&type=template&id=df6a5018&scoped=true"
import script from "./AdminUsersComponent.vue?vue&type=script&lang=js"
export * from "./AdminUsersComponent.vue?vue&type=script&lang=js"

import "./AdminUsersComponent.vue?vue&type=style&index=0&id=df6a5018&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6a5018"]])

export default __exports__